<div class="image-preview-dialog">
  <header mat-dialog-header>
    <p mat-dialog-title>{{ imgAltTxt }}</p>
    <button
      mat-icon-button
      class="close-icon"
      (click)="closeDialog()"
      (keyup.enter)="closeDialog()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section mat-dialog-content>
    <div class="adf-version-list-container">
      <img [src]="imageSrc" [alt]="imgAltTxt" loading="lazy" decoding="async" />
    </div>
  </section>

  <footer class="wk-modal-footer">
    <div class="wk-multimedia-footer">
      <div class="wk-button-group wk-button-group-right">
        <button
          type="button"
          class="wk-button"
          (click)="closeDialog()"
          (keyup.enter)="closeDialog()"
        >
          Dismiss
        </button>
      </div>
    </div>
  </footer>
</div>
